var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStartUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 395,
    height: 330,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M158.06 325.53c1.41-7.94-4.67-10.14-9.67-16.44-5-6.3-11-12.14-13.88-19.7-1.65-4.37-2.33-9.45-5.83-12.55-2.36-2.09-5.65-2.9-7.95-5.06-4.83-4.54-3.23-12.4-1.55-18.81 1.68-6.41 2.42-14.66-3.13-18.28-3.68-2.39-8.61-1.54-12.66-3.22-5.35-2.24-8-8.49-8.17-14.28-.17-5.79 1.56-11.46 2.38-17.2 4.25-29.5-15.38-58.51-11.35-88-2.54-.15-5.81-.4-8.34-.54.27 21 .53 42.17-3.47 62.79-4 20.62-12.63 40.9-27.78 55.45-5.81 5.57-13.15 11.81-12 19.78.68 4.9 4.63 9.6 3 14.26-.76 2.15-2.58 3.72-4.25 5.28a55.405 55.405 0 00-12.38 16.83c-5.72 12.18-9.7 32-21 39.33 50.75 2.92 107.25-2.58 158.03.36z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.51 65.99a17.23 17.23 0 013.42-8.35 2.91 2.91 0 011.31-1c1.31-.39 2.5.85 3.25 2 4.34 6.69 6.18 14.64 7.88 22.43 2.02 9.32 4.02 18.72 4.02 28.25a3.25 3.25 0 01-.25 1.58 3.22 3.22 0 01-2 1.34c-3.13 1-9.24 2.24-11.69-.75-2.17-2.65-2.11-8.85-2.79-12-2.34-10.99-5.12-22.27-3.15-33.5z",
    fill: "#4B39EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.85 39.79c1.21.2 61.65 25.76 61.65 25.76s1.41 24.46 1.21 23.85c-.2-.61-162.7 15.16-162.49 13.75.21-1.41-2.23-30.76-2.23-30.76l52.85-26.68 49.01-5.92z",
    fill: "#4B39EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.22 45.66c1.21.21 62.71 26.58 62.71 26.58s4 17.77 3.78 17.16c-.22-.61-162.7 15.16-162.49 13.75.21-1.41-1.83-24.09-1.83-24.09l53-27.28 44.83-6.12z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.28 101.71c1.85 1.44 3.53 3.49 5.88 3.63a8.109 8.109 0 003.25-.74 5.549 5.549 0 003.17-2.18 5.152 5.152 0 00.45-1.7 28.517 28.517 0 00-2.2-15.17c-.74-1.68-.33-6.53-2-7.33-1.67-.8-5 2.58-6.85 2.85-.187.02-.369.071-.54.15-.6.33-.55 1.19-.43 1.86a65.37 65.37 0 011.08 12.48c-.11-1.38-1.7-2.18-3.08-2.17-2.16 0-5.53 2.1-4.63 4.72.31.88 1.25 1.11 2 1.44a17.424 17.424 0 013.9 2.16z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.65 92.45a2 2 0 001.12 0c.77-.27 1-1.23 1.06-2a17.503 17.503 0 00-.3-3.14l-.94-5.92a.693.693 0 00-.13-.38.729.729 0 00-.58-.18 13.79 13.79 0 00-5 1l.54 4.33c.014.199.058.394.13.58.094.176.197.346.31.51.7 1.1 0 2.41.62 3.44.62 1.03 2.18 1.52 3.17 1.76z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.84.85a16.87 16.87 0 0111.4.3c.858.305 1.671.722 2.42 1.24 2.87 1.93 5.51 4.5 6.48 7.81.41 1.39.5 2.87.95 4.25a4.508 4.508 0 002.78 3.12 3.784 3.784 0 01-3.38 1.57 28.229 28.229 0 003.3 4.25 7.7 7.7 0 01-4.45-.4 7.875 7.875 0 01.61 3.25 8.578 8.578 0 01-3.48-1.08 1.691 1.691 0 01-1.8 1.19 5.092 5.092 0 01-2.18-.84l-3.42-2a29.527 29.527 0 01-7.1-5.15 22.82 22.82 0 01-3.19-4.71c-.81-1.5-5.17-3.05-5.3-4.79-.27-3.57 3.34-7.42 6.36-8.01z",
    fill: "#3E3E54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.54 79.91l1.45 5.85a31.708 31.708 0 001.1 3.71c1.43 3.65 4.28 6.74 5 10.59.13.65.27 1.42.88 1.68.377.12.783.12 1.16 0 3.6-.8 7.35-.36 11-.7a61.234 61.234 0 008.13-1.59 177.095 177.095 0 0125.17-4c.86-.08 1.89-.26 2.21-1.06.106-.322.137-.664.09-1-.49-7.69-4-14.79-6.43-22.1a1.381 1.381 0 01.88-2 93.577 93.577 0 0015.52-9.8l-6.14-9.36c-3.55-5.42-7.42-11.12-13.33-13.8-3.69-1.66-7.84-2-11.88-2-4.35 0-8.69.41-13 .8-2.743.111-5.47.466-8.15 1.06-7.31 2-18.38 7.83-21 13.62-7 15.37-3.61 29.94-4.24 30.83a3.01 3.01 0 00-.63 1c-.21.82.67 1.59 1.51 1.63a5 5 0 002.39-.77 21.564 21.564 0 018.29-2.18c-.04.19-.04-.64.02-.41z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.13 67.39a44.285 44.285 0 01-.31 5.87 1.893 1.893 0 01-.31 1 2.45 2.45 0 01-1.62.64c-6.82.87-13.74.65-20.63.44a2.142 2.142 0 01-.87-.16 1.6 1.6 0 01-.66-.79c-.63-1.34-1.42-4 .14-5.09 1.56-1.09 5.22-.62 7-.74l17.26-1.17z",
    fill: "#4B39EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.13 67.39a44.285 44.285 0 01-.31 5.87 1.893 1.893 0 01-.31 1 2.45 2.45 0 01-1.62.64c-6.82.87-13.74.65-20.63.44a2.142 2.142 0 01-.87-.16 1.6 1.6 0 01-.66-.79c-.63-1.34-1.42-4 .14-5.09 1.56-1.09 5.22-.62 7-.74l17.26-1.17z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.39 99.73c0-.47-.73-.38-1.12-.13-12 7.64-23.48 16-35 24.26a47.91 47.91 0 00-7.47 6.21c-2.2 2.41-4 5.43-4 8.69.04 1.79.413 3.557 1.1 5.21 4.44 11.88 15.2 20 22.89 30.12 3.84 5 7.07 10.75 12.25 14.39 1 .71 2.15 1.42 2.54 2.59-.12.12 1.17-.31 1.05-.19a54.538 54.538 0 0011.17-9 82.175 82.175 0 01-10-10.16c-1.64-1.86-3.28-3.72-4.74-5.72a84.722 84.722 0 01-6.56-11.16c-1.45-2.78-3.64-5-2.75-8 1.27-4.29 12.65-10.17 19.2-14 6.34-3.72 17-9.46 16.73-9.34 0 0-5.91 26.12 8.15 47s33.09 52.47 34.17 52.11c1.08-.36 10.82-14.07 10.82-14.07l-26.69-45.45s7.66-56.21 1.3-67.78l-43.04 4.42z",
    fill: "#3E3E54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.39 99.73c0-.47-.73-.38-1.12-.13-12 7.64-23.48 16-35 24.26a47.91 47.91 0 00-7.47 6.21c-2.2 2.41-4 5.43-4 8.69.04 1.79.413 3.557 1.1 5.21 4.44 11.88 15.2 20 22.89 30.12 3.84 5 7.07 10.75 12.25 14.39 1 .71 2.15 1.42 2.54 2.59-.12.12 1.17-.31 1.05-.19a54.538 54.538 0 0011.17-9 82.175 82.175 0 01-10-10.16c-1.64-1.86-3.28-3.72-4.74-5.72a84.722 84.722 0 01-6.56-11.16c-1.45-2.78-3.64-5-2.75-8 1.27-4.29 12.65-10.17 19.2-14 6.34-3.72 17-9.46 16.73-9.34 0 0-5.91 26.12 8.15 47s33.09 52.47 34.17 52.11c1.08-.36 10.82-14.07 10.82-14.07l-26.69-45.45s7.66-56.21 1.3-67.78l-43.04 4.42z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.72 195.44c.367 4.88.88 9.747 1.54 14.6.14 1 .38 2.17 1.27 2.65a2.734 2.734 0 002.68-.4 10 10 0 003.81-5.14 29.235 29.235 0 001.26-6.37l1.08-8.67c.15-1.26.25-2.7-.63-3.61-.88-.91-2.36-.86-3.6-1.19-1.9-.51-3.34-2-4.68-3.44-1.08 1.25-4.5 3.71-4.43 5.37 0 .89.94 1.93 1.19 2.8.284 1.113.455 2.252.51 3.4zm64.55 27.22c.376.907.619 1.863.72 2.84a90.435 90.435 0 002.21 9.33 9.105 9.105 0 001.11 2.8 3.094 3.094 0 002.51 1.47c1.68 0 2.73-1.8 3.38-3.34a30.909 30.909 0 002.58-9 14.738 14.738 0 00-1.78-9 3.122 3.122 0 00-1.08-1.17 7.69 7.69 0 00-1.94-.44c-1.78-.44-2.86-2.25-4.45-3.15a.922.922 0 00-.52-.17 1.138 1.138 0 00-.73.45 32.172 32.172 0 00-3.8 5c-.73 1.19-.94 1.35.09 2.29a7.212 7.212 0 011.7 2.09z",
    fill: "#3E3E54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.85 53.01a17.352 17.352 0 013.41-8.35c.335-.453.793-.8 1.32-1 1.31-.4 2.5.85 3.25 2 4.34 6.68 6.18 14.64 7.88 22.43 2 9.31 4 18.72 4.06 28.25a3.31 3.31 0 01-.25 1.57 3.171 3.171 0 01-2 1.34c-3.13 1-9.25 2.24-11.69-.74-2.17-2.66-2.11-8.85-2.8-12-2.38-10.99-5.16-22.27-3.18-33.5z",
    fill: "#4B39EF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M394.08 329.77c-18.18-3.36-30.37-20.21-39.52-36.27-2.29-4-4.65-8.21-8.46-10.82-3.81-2.61-9.55-3.06-12.71.31a90.868 90.868 0 00-11.13-25.33c-4.46-7-10.36-13.69-18.33-16-7.97-2.31-18.1 1.51-20.11 9.55-6.82.4-12-6.45-13.48-13.11-1.48-6.66-.69-13.71-2.51-20.29-1.21-4.41-3.58-8.57-3.79-13.13-.43-9.72 9-18.83 5.86-28-1.87-5.5-7.62-8.69-10.65-13.64-2-3.31-2.74-7.24-3.42-11.07l-9.63-54.75c-2.34.55-5.52 3.06-7.86 3.61 4.14 44.87 7.91 92.13-10.78 133.13-3.86 8.46-8.88 16.79-16.61 22-4.81 3.22-10.4 5-15.78 7.18-8.66 3.43-17.22 8-22.95 15.34s-8 18-3.45 26.13c3.29 5.89-.69 14.6-.3 21.33 71.63-1.21 153.98 4.95 225.61 3.83z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.39 35.73a17.76 17.76 0 01-6.22 10.79 10.002 10.002 0 01-4.1 2.17 5.43 5.43 0 01-4.44-.82 7.42 7.42 0 01-2.24-3.48c-.09-.25-.18-.51-.26-.76a4.789 4.789 0 011.52-5c.196-.177.367-.379.51-.6.087-.154.154-.319.2-.49.62-2.2-.45-3.89-.66-5.8a3.618 3.618 0 011.22-2.7 13.562 13.562 0 016.82-4.37 3.519 3.519 0 011.07-.12c2.18.1 2.58 2 2.82 3.58.18 1.18.36 2.35.53 3.53.085.97.357 1.914.8 2.78a2.52 2.52 0 002.43 1.29z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.9 25.13a22.116 22.116 0 01-1.66 6.91c-2.73 5.92-8.06 6-8.06 6 .087-.154.154-.319.2-.49.62-2.2-.45-3.89-.66-5.8l10.18-6.62z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.49 21.25a14.203 14.203 0 00-1.3 4 7.177 7.177 0 001.75 5.43 7.073 7.073 0 005.2 2.35 10.517 10.517 0 003.78-.79 21.323 21.323 0 008.69-6.12 2.75 2.75 0 002.72 1.06 5.293 5.293 0 002.66-1.47 2.873 2.873 0 001.14-2.24c-.13-1.33-1.68-1.95-3-2.29a10.828 10.828 0 002.7-3.26 7.23 7.23 0 00-1.42-7.74 10.34 10.34 0 00-7.53-3.06c-1.53 0-3.05.25-4.58.38a16.103 16.103 0 00-4 .6c-1.69.6-1.92 1.85-2.59 3.4l-4.22 9.75z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.93 96.77h-4.61a5.458 5.458 0 01-1.21-1.5c-6.13-10.6-5.23-58.86-3.39-61 1.63-1.94 7.41-1.75 9.2-1.64h.54l2.75 1.69c-6.2 13.12-3.28 62.45-3.28 62.45z",
    fill: "#4B39EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.01 95.27h-2.9c-6.13-10.6-5.23-58.86-3.39-61 1.63-1.94 7.41-1.75 9.2-1.64l.36.22c-6.2 13.08-3.27 62.42-3.27 62.42z",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.39 105.25a8.565 8.565 0 01-7.35-4.19l-17.46-29.31a1.646 1.646 0 01.61-2.194 1.65 1.65 0 012.22.504l17.51 29.33a5.223 5.223 0 005.23 2.52c11.93-1.61 17.88-2.77 19.72-3.37v-4.3a1.642 1.642 0 01.441-1.184 1.644 1.644 0 011.149-.526 1.65 1.65 0 011.71 1.59c0 .41.13 4 0 5.52-.13 1.52-.92 2.1-9.2 3.54-4.38.76-9.67 1.51-13.33 2a9.007 9.007 0 01-1.25.07zm-49.61 5.36a3.256 3.256 0 01-1.6-.43 6.465 6.465 0 01-1.78-1.808 6.455 6.455 0 01-.95-2.352l-8.1-29.3a1.651 1.651 0 011.155-2.035 1.656 1.656 0 012.035 1.155l8.09 29.3c.42 1.52 1 2.07 1.17 2.16 5.34-1.56 7.78-2.61 8.58-3.09.17-2.42.83-9.64.86-10a1.655 1.655 0 011.795-1.495 1.65 1.65 0 011.495 1.795c-.28 3.1-.83 9.26-.88 10.38-.06 1.36-1.2 2.22-4.7 3.54-2.07.77-4.55 1.53-6.27 2a3.11 3.11 0 01-.9.18z",
    fill: "#4B39EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.39 105.39a8.542 8.542 0 01-7.35-4.18L149.57 71.9a1.649 1.649 0 011.805-2.415c.417.095.781.347 1.015.705l17.47 29.31a5.265 5.265 0 005.22 2.52c11.94-1.61 17.89-2.77 19.73-3.37v-4.31a1.65 1.65 0 012.778-1.26c.32.299.507.712.522 1.15 0 .41.14 4 0 5.52-.14 1.52-.92 2.1-9.2 3.54-4.39.76-9.67 1.51-13.33 2a7.644 7.644 0 01-1.19.1z",
    fill: "url(#paint9_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.39 105.12a8.558 8.558 0 01-7.35-4.18l-17.46-29.31a1.645 1.645 0 011.155-2.548 1.648 1.648 0 011.675.858l17.47 29.3a5.26 5.26 0 005.23 2.53c11.93-1.62 17.88-2.78 19.72-3.38v-4.3a1.65 1.65 0 011.56-1.7 1.667 1.667 0 011.71 1.6c0 .4.13 4 0 5.52-.13 1.52-.92 2.09-9.2 3.53-4.38.76-9.67 1.51-13.33 2a8.95 8.95 0 01-1.18.08z",
    fill: "url(#paint10_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.75 110.61a3.232 3.232 0 01-1.6-.43 6.532 6.532 0 01-2.74-4.16l-8.09-29.3a1.651 1.651 0 011.791-2.104 1.65 1.65 0 011.389 1.224l8.1 29.3a3.73 3.73 0 001.16 2.16c5.35-1.56 7.79-2.61 8.59-3.09.17-2.42.83-9.64.86-10a1.651 1.651 0 113.29.3c-.28 3.1-.84 9.26-.88 10.38-.06 1.36-1.2 2.22-4.71 3.54-2.06.77-4.54 1.53-6.26 2a3.11 3.11 0 01-.9.18z",
    fill: "url(#paint11_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    d: "M124.94 110.55a3.256 3.256 0 01-1.6-.43 6.558 6.558 0 01-2.74-4.16l-8.09-29.31a1.649 1.649 0 013.18-.88l8.1 29.31a3.78 3.78 0 001.16 2.16c5.35-1.57 7.79-2.61 8.59-3.1.17-2.42.83-9.64.86-10a1.655 1.655 0 011.795-1.495 1.653 1.653 0 011.495 1.795c-.28 3.1-.84 9.26-.88 10.38-.06 1.36-1.2 2.22-4.7 3.53-2.07.78-4.55 1.54-6.27 2a3.123 3.123 0 01-.9.2z",
    fill: "url(#paint12_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.8 82.33a6.05 6.05 0 012.27.46 2.523 2.523 0 011.46 1.7c.14.71-.12 1.47.13 2.15.25.68.72 1 .9 1.54.34 1-.54 2.16-.25 3.21.13.47.48.86.6 1.34.092.456.036.929-.16 1.35-1 2.6-4.14 3.8-6.94 3.72a6.45 6.45 0 01-4.46-1.63 7.316 7.316 0 01-1.68-3.74 26.134 26.134 0 01-.58-5.29c-.04-4.9 4.74-5 8.71-4.81z",
    fill: "url(#paint13_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.55 61.23s13.78 26.28 9.86 30.52c-3.92 4.24-35.29 1.16-35.29 1.16-2.85-.14-5.09 2.33-7.91 2.72a5.598 5.598 0 01-5.34-2.41 4.358 4.358 0 00-1.29-1.58c-.3-.17-.66-.23-1-.38-1.28-.6-1.5-2.32-1.46-3.74a1.254 1.254 0 00-.14-.79 1.592 1.592 0 00-.39-.34 2.575 2.575 0 01-.49-3.08 4.822 4.822 0 012.55-2.12c1-.43 2.15-.65 3.21-1a12.692 12.692 0 003.89-2.16c.76-.62 1.69-1.38 2.61-1 .335.157.632.386.87.67l3 3.08a3.398 3.398 0 003 1.35l10.51.38a18.2 18.2 0 006.79-.62l-7.44-10.36c-.27-.38-.55-.85-.36-1.28.137-.23.339-.414.58-.53 4.81-2.93 9.49-5.61 14.24-8.49z",
    fill: "url(#paint14_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.04 22.63a1.09 1.09 0 01.84.11c.369.138.67.414.84.77a1.66 1.66 0 01-.5 1.51 2.802 2.802 0 01-1.94 1.18 1.58 1.58 0 01-1.5-1 1.257 1.257 0 01.72-1.57c.29-.08.54 0 .81-.22s.39-.64.73-.78z",
    fill: "url(#paint15_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.39 99.73l-2.23.41-1.38.25-5.89-19.7c-10.81-18.38-6.47-38-4.76-40 .7-.83 2.64-1.47 4.66-1.93a53.63 53.63 0 015.81-1c-5.41 11.92 3.79 61.97 3.79 61.97z",
    fill: "#4B39EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.18 100.14l-1.38.25-5.89-19.7c-10.81-18.38-6.47-38-4.76-40 .7-.83 2.64-1.47 4.66-1.93 2.02-.46 3.59-.52 3.59-.52-5.35 11.71 3.52 60.49 3.78 61.9z",
    fill: "url(#paint16_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.39 67.01s9.39 12.4 7.8 14c-1.59 1.6-5.67 1.41-5.67 1.41a2.315 2.315 0 00-.27-2.39c-.89-1.33-7.09-10-7.09-10l5.23-3.02z",
    fill: "url(#paint17_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 153.02,
    y1: 25.81,
    x2: 174.55,
    y2: 229.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 116.24,
    y1: 91.72,
    x2: 135.26,
    y2: 91.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5C5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EAD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0E9CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 988.434,
    y1: 1550.39,
    x2: 1455.47,
    y2: 1762.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5C5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EAD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0E9CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 3977.54,
    y1: 959.545,
    x2: 3984.16,
    y2: 1126.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 16468.9,
    y1: 29007.1,
    x2: 23412.5,
    y2: 24925.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 2662.02,
    y1: 2000.44,
    x2: 2966.51,
    y2: 2000.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5C5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EAD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0E9CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 1679.31,
    y1: 1002.03,
    x2: 1343.8,
    y2: 1495.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5C5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EAD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0E9CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 3719.35,
    y1: 1684.64,
    x2: 4408.62,
    y2: 1684.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5C5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EAD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0E9CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 2061.46,
    y1: 5751.73,
    x2: 332.827,
    y2: 6572.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 8016.9,
    y1: 5165.41,
    x2: 9945.34,
    y2: 3363.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 166.72,
    y1: 88.89,
    x2: 159.11,
    y2: 92.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#fff",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#fff",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 2965.74,
    y1: 5209.24,
    x2: 4358.8,
    y2: 4772.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 3307.5,
    y1: 4984.94,
    x2: 3168.84,
    y2: 5010.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#fff",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#fff",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 1715.08,
    y1: 2172.65,
    x2: 1907.36,
    y2: 2172.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5C5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EAD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0E9CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 8593.27,
    y1: 4300.35,
    x2: 11542.1,
    y2: 4300.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5C5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EAD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0E9CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 802.642,
    y1: 259.083,
    x2: 782.862,
    y2: 300.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5C5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EAD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0E9CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 2380.51,
    y1: 6379.4,
    x2: 1072.57,
    y2: 6580.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 2635.28,
    y1: 1915.82,
    x2: 2917.29,
    y2: 1885.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5C5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EAD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0E9CB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h394.08v329.91H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartUp);
export default __webpack_public_path__ + "static/media/start_up.d9803020fd72a65a8d880815edbf34b0.svg";
export { ForwardRef as ReactComponent };